/* assets/bundle-cards.js  —  SWERV bundle cards
   Adds:
     - a "Recommended" ribbon on the SWERV + Sensors card
     - the base card shows its real price; upgrade cards show the upcharge
       ("+$99") so the cost of adding sensors is obvious at a glance
     - a "Save $X" pill on any bundle Shopify holds a compare-at price for
     - on the 3 Filters pill: "+$49", the struck-through list price, and a
       "Save X%" badge, all derived from real prices
     - prices without the .00 on whole dollars

   The card prices and the Save pill read the real variant price and compare-at
   price from Shopify, so they can never advertise a discount that is not
   actually being given. Change a price in Shopify and the cards follow.

   Styles are injected by this file, so base.css is untouched. */

(function () {
  /* ---------------- CONFIG ---------------- */
  // Price of ONE replacement filter on the site, in cents. Currently $49.
  // If you ever change the filter price, change it here and the struck price
  // and the percentage both follow automatically.
  var FILTER_SINGLE_PRICE_CENTS = 4900;
  // How many MORE filters the 3-filter bundle gives you than the 1-filter bundle.
  var EXTRA_FILTERS_IN_BUNDLE = 2;
  /* ---------------------------------------- */

  var DIAGRAMS = {
    sensors: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><path d="M3 3v18h18"></path><path d="M6 16l3-5 3 3 3-6 3 4"></path></svg>',
    base: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><rect x="3" y="8" width="18" height="8" rx="2"></rect><line x1="7" y1="11" x2="7" y2="13"></line><line x1="11" y1="11" x2="11" y2="13"></line><line x1="15" y1="11" x2="15" y2="13"></line></svg>'
  };
  var CHECK = '<svg class="product__bundle-check" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><polyline points="20 6 9 17 4 12"></polyline></svg>';
  var DESCRIPTIONS = {
    sensors: "Sensors enable Auto Mode to adjust ventilation to your room's CO2 automatically. When it's a comfortable temperature outside, it switches to free cooling with fresh outdoor air.",
    base: "Simple, reliable manual fan control."
  };

  /* ---------- Styles, injected here so base.css stays untouched ----------
     Badge sizes are px: Dawn's root font-size is 10px, so rem values rendered at 6-7px. */
  var STYLES = [
    '.product__bundle-fieldset label.product__bundle-label--recommended,',
    '.product__bundle-fieldset .product__bundle-label--recommended {',
    '  position: relative; border-color: #2f7d6d; overflow: hidden;',
    '}',
    '.product__bundle-ribbon {',
    '  position: absolute; top: 0; right: 0;',
    '  display: flex; align-items: center; gap: 0.35em;',
    '  padding: 0.4em 0.7em; background: #2f7d6d; color: #fff;',
    '  font-size: 11px; font-weight: 700; letter-spacing: 0.06em;',
    '  text-transform: uppercase; border-bottom-left-radius: 8px; line-height: 1;',
    '}',
    '.product__bundle-ribbon .product__bundle-check { width: 0.9em; height: 0.9em; flex: 0 0 auto; }',
    '.product__bundle-promo {',
    '  display: flex; align-items: baseline; justify-content: center;',
    '  flex-wrap: wrap; gap: 0.45em; margin-top: 0.25em; line-height: 1.3;',
    '}',
    '.product__bundle-promo s { opacity: 0.55; font-size: 14px; }',
    '.product__bundle-promo em {',
    '  font-style: normal; font-size: 12px; font-weight: 700;',
    '  letter-spacing: 0.04em; text-transform: uppercase; color: #fff;',
    '  background: #2f7d6d; padding: 0.22em 0.5em; border-radius: 999px; white-space: nowrap;',
    '}',
    '.product__filter-fieldset label { position: relative; flex-wrap: wrap; row-gap: 0.2em; }',
    '.product__filter-delta { margin-left: 0.5em; font-weight: 700; color: #2f7d6d; white-space: nowrap; }',
    '.product__filter-was { margin-left: 0.3em; opacity: 0.5; white-space: nowrap; }',
    '.product__filter-save {',
    '  margin-left: 0.4em; font-size: 11px; font-weight: 700;',
    '  letter-spacing: 0.04em; text-transform: uppercase; color: #fff;',
    '  background: #2f7d6d; padding: 0.22em 0.5em; border-radius: 999px; white-space: nowrap;',
    '}',
    '@media (max-width: 480px) {',
    '  .product__bundle-ribbon { font-size: 10px; padding: 0.35em 0.55em; }',
    '  .product__bundle-promo em { font-size: 11px; }',
    '  .product__filter-save { font-size: 10px; }',
    '}'
  ].join('\n');

  var STYLE_ID = "swerv-bundle-card-styles";
  (function injectStyles() {
    if (document.getElementById(STYLE_ID)) return;
    var el = document.createElement("style");
    el.id = STYLE_ID;
    el.textContent = STYLES;
    (document.head || document.documentElement).appendChild(el);
  })();

  function isNoSensors(value) { return /no sensors/i.test(value); }
  function shortSensorLabel(value) { return isNoSensors(value) ? "SWERV" : "SWERV + Sensors"; }

  // Whole dollars render as $799, not $799.00. Cents only appear if there are any.
  function money(cents) {
    var d = cents / 100;
    return "$" + (d % 1 === 0 ? d.toFixed(0) : d.toFixed(2));
  }
  function delta(cents) { return "+$" + Math.round(cents / 100); }

  function enhance() {
    var script = document.querySelector("script[data-bundle-cards-variants]");
    var container = document.querySelector("variant-selects");
    if (!script || !container) return;

    var variants;
    try { variants = JSON.parse(script.textContent); } catch (e) { return; }

    var sensorsFieldset = null, filtersFieldset = null;
    container.querySelectorAll("fieldset").forEach(function (fieldset) {
      var legend = fieldset.querySelector("legend");
      if (!legend) return;
      var text = legend.textContent.trim().toLowerCase();
      if (text === "sensors") sensorsFieldset = fieldset;
      if (text === "filters") filtersFieldset = fieldset;
    });
    if (!sensorsFieldset || !filtersFieldset) return;

    sensorsFieldset.classList.add("product__bundle-fieldset");
    filtersFieldset.classList.add("product__filter-fieldset");

    function optionKeyFor(fieldset) {
      var sample = fieldset.querySelector('input[type="radio"]');
      var match = sample && sample.name.trim().match(/-(\d+)$/);
      return match ? "option" + match[1] : null;
    }
    var sensorKey = optionKeyFor(sensorsFieldset);
    var filterKey = optionKeyFor(filtersFieldset);

    // Cheapest variant for a given option value, so each card shows a "from" price
    function cheapestVariant(key, value) {
      if (!key) return null;
      var matching = variants.filter(function (v) { return v[key] === value; });
      if (!matching.length) return null;
      return matching.reduce(function (a, b) { return b.price < a.price ? b : a; });
    }

    /* ---------- Sensor bundle cards ---------- */
    var sensorInputs = Array.prototype.slice.call(sensorsFieldset.querySelectorAll('input[type="radio"]'));

    // The lowest-priced bundle is the baseline. Every other card shows what it
    // ADDS to that baseline rather than its own full price, so "+$99" reads as
    // the cost of the sensors instead of looking like a second product price.
    // Derived from live Shopify prices, so it follows any price change.
    var baseSensorPrice = null;
    sensorInputs.forEach(function (input) {
      var v = cheapestVariant(sensorKey, input.value);
      if (v && (baseSensorPrice === null || v.price < baseSensorPrice)) baseSensorPrice = v.price;
    });

    sensorInputs.forEach(function (input) {
      var label = sensorsFieldset.querySelector('label[for="' + input.id + '"]');
      if (!label) return;

      var fullText = label.textContent.trim();
      var recommended = !isNoSensors(input.value);
      var unavailableEl = label.querySelector(".label-unavailable");
      var variant = cheapestVariant(sensorKey, input.value);

      label.setAttribute("aria-label", fullText + (recommended ? ". Recommended." : ""));
      label.textContent = "";
      label.classList.toggle("product__bundle-label--recommended", recommended);

      if (recommended) {
        var ribbon = document.createElement("span");
        ribbon.className = "product__bundle-ribbon";
        ribbon.innerHTML = CHECK + "<span>Recommended</span>";
        label.appendChild(ribbon);
      }

      var diagramEl = document.createElement("span");
      diagramEl.className = "product__bundle-diagram";
      diagramEl.setAttribute("aria-hidden", "true");
      diagramEl.innerHTML = isNoSensors(input.value) ? DIAGRAMS.base : DIAGRAMS.sensors;
      label.appendChild(diagramEl);

      var nameEl = document.createElement("span");
      nameEl.className = "product__bundle-name";
      nameEl.textContent = shortSensorLabel(input.value);
      label.appendChild(nameEl);

      if (variant) {
        var upcharge = (baseSensorPrice === null) ? 0 : variant.price - baseSensorPrice;

        var priceEl = document.createElement("span");
        priceEl.className = "product__bundle-price";
        // Baseline card keeps its real price; upgrade cards show the add-on cost.
        priceEl.textContent = upcharge > 0 ? delta(upcharge) : money(variant.price);
        label.appendChild(priceEl);

        // Only shows a discount if Shopify actually holds a higher compare-at price.
        // The struck-through full price is deliberately NOT shown here: next to an
        // "+$99" headline it reads as a discount off the add-on rather than off the
        // bundle total. The Save pill carries the message on its own.
        var wasPrice = variant.compare_at_price;
        if (wasPrice && wasPrice > variant.price) {
          var saveEl = document.createElement("span");
          saveEl.className = "product__bundle-promo";
          saveEl.innerHTML = '<em>Save ' + money(wasPrice - variant.price) + '</em>';
          label.appendChild(saveEl);
        }
      }

      var descEl = document.createElement("span");
      descEl.className = "product__bundle-description";
      descEl.textContent = isNoSensors(input.value) ? DESCRIPTIONS.base : DESCRIPTIONS.sensors;
      label.appendChild(descEl);

      if (unavailableEl) label.appendChild(unavailableEl);
    });

    var sensorsLegend = sensorsFieldset.querySelector("legend");
    if (sensorsLegend) {
      sensorsLegend.setAttribute("aria-label", sensorsLegend.textContent.trim());
      sensorsLegend.textContent = "Choose your bundle";
      sensorsLegend.classList.add("product__bundle-heading");
    }

    /* ---------- Filter pills ---------- */
    var filterInputs = Array.prototype.slice.call(filtersFieldset.querySelectorAll('input[type="radio"]'));
    var cheapestFilterPrice = null;
    filterInputs.forEach(function (input) {
      var v = cheapestVariant(filterKey, input.value);
      if (v && (cheapestFilterPrice === null || v.price < cheapestFilterPrice)) cheapestFilterPrice = v.price;
    });

    filterInputs.forEach(function (input) {
      var label = filtersFieldset.querySelector('label[for="' + input.id + '"]');
      if (!label) return;

      // Clear anything a previous run added, so re-renders never stack up
      label.querySelectorAll(".product__filter-extra").forEach(function (el) { el.remove(); });

      var variant = cheapestVariant(filterKey, input.value);
      var upcharge = (variant && cheapestFilterPrice !== null) ? variant.price - cheapestFilterPrice : 0;

      if (upcharge > 0) {
        var deltaEl = document.createElement("span");
        deltaEl.className = "product__filter-extra product__filter-delta";
        deltaEl.textContent = delta(upcharge);
        label.appendChild(deltaEl);

        // What those extra filters would cost bought one at a time
        var listPrice = FILTER_SINGLE_PRICE_CENTS * EXTRA_FILTERS_IN_BUNDLE;
        if (listPrice > upcharge) {
          var wasEl = document.createElement("s");
          wasEl.className = "product__filter-extra product__filter-was";
          wasEl.textContent = money(listPrice);
          label.appendChild(wasEl);

          var percentOff = Math.round((1 - upcharge / listPrice) * 100);
          var pctEl = document.createElement("span");
          pctEl.className = "product__filter-extra product__filter-save";
          pctEl.textContent = "Save " + percentOff + "%";
          label.appendChild(pctEl);
        }
      }
    });

    container.insertBefore(sensorsFieldset, filtersFieldset);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", enhance);
  } else {
    enhance();
  }
  if (typeof subscribe === "function" && typeof PUB_SUB_EVENTS === "object") {
    subscribe(PUB_SUB_EVENTS.variantChange, enhance);
  }

  /* ---------- Preorder message ordering (unchanged from the original file) ---------- */
  function reorderPreorderMessages() {
    var topMessageParent = document.querySelector(".gPreorderTopMessageParent");
    var buttons = document.querySelector(".product-form__buttons");
    var warning = document.querySelector(".gPreorderWarning");
    var bottomMessage = document.querySelector(".gPreorderBottomMessage");
    if (!topMessageParent || !buttons || !warning || !bottomMessage) return false;

    var parent = buttons.parentElement;
    if (parent !== topMessageParent.parentElement || parent !== warning.parentElement || parent !== bottomMessage.parentElement) return false;

    var desired = [buttons, topMessageParent, warning, bottomMessage];
    var current = Array.prototype.filter.call(parent.children, function (el) { return desired.indexOf(el) !== -1; });
    var alreadyCorrect = desired.every(function (el, i) { return current[i] === el; });
    if (!alreadyCorrect) desired.forEach(function (el) { parent.appendChild(el); });
    return true;
  }
  reorderPreorderMessages();

  var reorderCount = 0;
  var reorderWindowStart = Date.now();
  var preorderObserver = new MutationObserver(function () {
    var now = Date.now();
    if (now - reorderWindowStart > 1000) { reorderWindowStart = now; reorderCount = 0; }
    reorderCount++;
    if (reorderCount > 20) { preorderObserver.disconnect(); return; }
    preorderObserver.disconnect();
    reorderPreorderMessages();
    preorderObserver.observe(document.body, { childList: true, subtree: true });
  });
  preorderObserver.observe(document.body, { childList: true, subtree: true });
})();
